import { Grid, Typography } from "@mui/material";
import { PaleteEnum } from "../../../interfaces/Enums";
import { useAuthentication } from "../../../store/Authentication";
import SelectTeamComponent from "./Components/SelectTeam";

export default function PinActive() {
  const { profile } = useAuthentication();

  
  let validityPin;

  if (profile.dataFimPrevista) {
    validityPin = new Date(
      profile?.dataFimPrevista
    ).toLocaleDateString("pt-BR");
  }

  return (
    <Grid
      container
      flexDirection={"column"}
      alignItems={"center"}
      justifyItems={"center"}
      p={4}
      pt={{ md: 10 }}
    >
      <Grid item container width={{ md: "50%", lg: "35%" }} rowSpacing={2}>
        <Grid item container flexDirection={"column"}>
          <Typography variant="h6" align="center">
            Bem vindo, <strong>{profile.nome}</strong>
          </Typography>
          <Typography variant="body1" mt={4}>
            Parece que você já possui o NBA Team Pass ativo. Aguarde até o
            término da sua validade até resgatar o novo código.
          </Typography>
          
          {/* <Typography variant="body1" mt={1}>
            Para mais informações, entre em contato:
          </Typography> */}
          {/* <Link href="#">www.epayNBA.com/suporte</Link> */}
          <SelectTeamComponent></SelectTeamComponent>
          
          {validityPin?
            <Typography variant="body1" color={PaleteEnum.bluePrimary} mt={4}>
              NBA válida até:{" "}
              <strong>
                <u>{validityPin}</u>
              </strong>
            </Typography>
            : ''
          }
          
        </Grid>
      </Grid>
    </Grid>
  );
}
